import cn from 'classnames';

import ContentContainer from 'components/content-container/ContentContainer';
import { ContentWithSidebar, Sidebar, Content } from 'components/content-with-sidebar';
import StickyMenuOnTabs from 'components/sticky-menu-on-tabs/StickyMenuOnTabs';
import TabContentSection from 'components/tab-content-section/TabContentSection';

import { ITabContent } from 'source/NFR.types';

const TabContent: React.FC<ITabContent> = ({ menu, contentSections }) => {
  const tabContent = (
    <>
      {contentSections?.map((contentSection, index) => (
        <TabContentSection {...contentSection} key={index} />
      ))}
    </>
  );

  const className = 'tab-content';
  return !menu ? (
    <ContentContainer theme="medium" className={className}>
      {tabContent}
    </ContentContainer>
  ) : (
    <ContentContainer className={cn(className, 'tab-content__container')} theme="wide">
      <ContentWithSidebar theme={'sidebarLeft'} className="tab-content__grid" useContentContainer={false}>
        <Sidebar>
          <StickyMenuOnTabs {...menu} />
        </Sidebar>
        <Content className="tab-content__content">{tabContent}</Content>
      </ContentWithSidebar>
    </ContentContainer>
  );
};

TabContent.displayName = 'TabContent';

export default TabContent;
